import { useAppDispatch, useAppSelector } from "../../../store/types";
import type { MenuItem } from "../../SbuxSelect/index";
import SbuxSelect from "../../SbuxSelect";
import { useState } from "react";
import { getSelectedTimezone } from "../../../services/settings";
import { Box } from "@mui/material";
import { Divider } from "@mui/material";
import { getTimezonesSelector } from "../../../selectors/globalConfigSelectors";
import { getTimezoneSelector } from "../../../selectors/settingsSelector";
import SbuxTranslate from "../../../components/SbuxTranslate";

const TimeZoneList = () => {
  const dispatch = useAppDispatch();

  const timezones = useAppSelector(getTimezonesSelector) as
    | MenuItem[]
    | undefined;
  const timezone = useAppSelector(getTimezoneSelector);

  const [timeZoneValue, setTimeZoneValue] = useState(timezone);
  const handleTimeZoneChange = async (timezone: string) => {
    setTimeZoneValue(timezone);
    await dispatch(getSelectedTimezone(timezone));
  };
  return (
    <Box
      sx={{
        paddingLeft: 2,
        paddingTop: 0.5,
        paddingBottom: 0.5,
        paddingRight: 1,
      }}
    >
      <Box>
        <SbuxSelect
          label={<SbuxTranslate>{"Timezone"}</SbuxTranslate>}
          menuItems={timezones}
          defaultValue={timeZoneValue}
          value={timeZoneValue}
          handleSelectChange={(timezone) => handleTimeZoneChange(timezone)}
        />
      </Box>

      <Divider sx={{ marginTop: 1 }} />
    </Box>
  );
};
export default TimeZoneList;
